import { useFormikContext } from 'formik';
import { CredentialsFormValues } from './types';

export function useCredentialsForm() {
  return useFormikContext<CredentialsFormValues>();
}
